import styled from "styled-components";

export const Container = styled.div`
    width: 96%;
    margin: 1rem auto;

    h2{
        text-align: center;
        margin-bottom: 3rem;
        color: #7A05A7
    }

    .containerProperties{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }
`

export const Button = styled.button`
    background: #CCC;
    color: #FFF;
    padding: 2.5rem;
    border-radius: 10px;
    width: 100%;
    max-width: 30rem;
    margin: 1rem auto;
    border: none;

    display: flex;
    align-items: center;
    justify-content: center;
    transition: filter 0.2s;

    svg{
        font-size: 2.5rem;
    }

    &:hover{
        filter: brightness(0.95);
        cursor: pointer;
    }
`